/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TWebDeleteFavoritesRequest,
  TWebDeleteFavoritesModel,
  IMappers,
  TWebDeleteFavoritesResponse,
  TWebDeleteFavoritesResponseData200,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createWebDeleteFavoritesModel(parameters: TWebDeleteFavoritesRequest): TWebDeleteFavoritesModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'favorites',
    pathApi: '/v1/web/delete-favorites/',
    response: {
      200: {},
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IWebDeleteFavoritesOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TWebDeleteFavoritesRequest;
}

export async function fetchWebDeleteFavorites<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IWebDeleteFavoritesOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TWebDeleteFavoritesResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createWebDeleteFavoritesModel(parameters),
    config,
  )) as FetchResponse<TWebDeleteFavoritesResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TWebDeleteFavoritesResponseData200, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TWebDeleteFavoritesResponse>;
}
